/**
 * Utility functions for processing auto-logout configuration values from CustomerSettings
 */

const MIN_DURATION_MS = 600000; // 10 minutes minimum
const MAX_DURATION_MS = 3600000; // 60 minutes maximum
const DEFAULT_DURATION_MS = 1200000; // 20 minutes default
// const DEFAULT_DURATION_MS = 20000; // 20 second (testing)
const DEFAULT_ALERT_THRESHOLD_MS = 300000; // 5 minutes default
// const DEFAULT_ALERT_THRESHOLD_MS = 10000; // 10 seconds (testing)

/**
 * Process auto-logout duration value from CustomerSettings
 * Defaults to 20 minutes if not set. Enforces minimum of 10 minutes, maximum of 60 minutes.
 * If a customer setting is less than 10 minutes, it will be clamped to 10 minutes.
 * @param {number|null|undefined} value - Raw value from CustomerSettings (in milliseconds)
 * @returns {number} Processed duration in milliseconds
 */
export const processAutoLogoutDuration = value => {
  if (value == null || value === undefined) return DEFAULT_DURATION_MS;
  const numValue = Number(value);
  if (Number.isNaN(numValue)) return DEFAULT_DURATION_MS;
  if (numValue < MIN_DURATION_MS) return MIN_DURATION_MS;
  if (numValue > MAX_DURATION_MS) return MAX_DURATION_MS;
  return numValue;
};

/**
 * Process auto-logout alert threshold value from CustomerSettings
 * Defaults to 5 minutes if not set
 * @param {number|null|undefined} value - Raw value from CustomerSettings (in milliseconds)
 * @returns {number} Processed threshold in milliseconds
 */
export const processAutoLogoutAlertThreshold = value => {
  if (value == null || value === undefined) return DEFAULT_ALERT_THRESHOLD_MS;
  const numValue = Number(value);
  return Number.isNaN(numValue) ? DEFAULT_ALERT_THRESHOLD_MS : numValue;
};
export default {
  processAutoLogoutDuration,
  processAutoLogoutAlertThreshold
};